module.exports = __webpack_public_path__ + "assets/img/night.f4e4e1a9.svg";